// `changeSpot` is only on the library's internal SpotlightTourCtx, not exposed by the
// public `useSpotlightTour()` hook. Pin the exact dependency version (no `^`) since this
// reaches past its public API and could break silently on a minor/patch bump.
export { SpotlightTourContext } from 'react-native-spotlight-tour/src/lib/SpotlightTour.context';
